import React from 'react';
import PropTypes from 'prop-types';

export default function BusinessDropdownItem({ children, ...props }) {
  return (
    <button
      type="button"
      aria-label=""
      className="business-dropdown-item"
      {...props}
    >
      {children}
    </button>
  );
}

BusinessDropdownItem.propTypes = {
  children: PropTypes.object.isRequired,
};
